import uiTexts from 'data/ui-texts';

export function getText (textId, textListId) {
	return uiTexts[textListId][textId];
};